import { render, staticRenderFns } from "./SHotZone.vue?vue&type=template&id=cf8ad7c0&scoped=true"
import script from "./SHotZone.vue?vue&type=script&lang=js"
export * from "./SHotZone.vue?vue&type=script&lang=js"
import style0 from "./SHotZone.vue?vue&type=style&index=0&id=cf8ad7c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8ad7c0",
  null
  
)

export default component.exports